import { useId, type ReactNode, type TextareaHTMLAttributes } from 'react'
import { cn } from '../../utils/cn'
import { FormField } from './FormField'
import { CONTROL_BASE, controlTone, describedBy } from './fieldStyles'

export interface TextareaProps extends Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'id'> {
  label: ReactNode
  id?: string
  hint?: ReactNode
  error?: ReactNode
  containerClassName?: string
}

export function Textarea({
  label,
  id,
  hint,
  error,
  required,
  rows = 3,
  className,
  containerClassName,
  ...rest
}: TextareaProps) {
  const autoId = useId()
  const fieldId = id ?? autoId

  return (
    <FormField
      id={fieldId}
      label={label}
      hint={hint}
      error={error}
      required={required}
      className={containerClassName}
    >
      <textarea
        {...rest}
        id={fieldId}
        rows={rows}
        required={required}
        aria-invalid={error ? true : undefined}
        aria-describedby={describedBy(fieldId, hint, error)}
        className={cn(CONTROL_BASE, controlTone(Boolean(error)), 'resize-none', className)}
      />
    </FormField>
  )
}
